<template>
  <div>
    <div class="tab_">
      <span
        v-for="(item, index) in quotationData.labelContents"
        :key="index + 'tab'"
        @click="changeTab(item, index)"
        :class="{ on: index == nowTabIndex }"
        >{{ item.contentTitle }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    quotationData: {
      type: Object,
      default: {
        labelContents: [],
      },
    },
  },
  data(){
      return {
          nowTabIndex: 0,
      }
  },
  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.quoteId = id;
    }
    const tab = sessionStorage.getItem("tab_");
    if (tab) {
      this.nowTabIndex = tab;
    }
  },
  methods: {
    changeTab(item, index) {
      sessionStorage.setItem("tab_", index);
      this.$router.push({
        name: "modelContent",
        query: { id: item.id, qid: this.quoteId },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.tab_ {
    display: flex;
    width: 92%;
    margin: 0 auto;
    color: #007aff;
    span {
      flex: 1;
      padding: 10px;
      text-align: center;
      position: relative;
      &.on::after {
        position: absolute;
        content: "";
        display: block;
        width: 20px;
        height: 1px;
        background-color: #007aff;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
    }
  }
</style>